import React, { useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { withRouter } from "react-router";
import "../../../css/plantillas.css";
import RatingIcon from "../Plantillas/Respuestas/valoracionestrellas/valoracion";
import VerdaderoFalso from "../Plantillas/Respuestas/verdaderoFalso";

const returnMatrix = (opciones) => {
  var temp = [];
  if (opciones.length > 1) {
    for (
      var i = parseInt(opciones[0].valor);
      i < parseInt(opciones[1].valor) + 1;
      i++
    ) {
      temp = [...temp, i];
      console.log(temp);
    }
  }
  return temp;
};

const CampoPreguntaEncuesta = (props) => {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const onMouseEnter = (index) => {
    setHoverRating(index);
  };
  const onMouseLeave = () => {
    setHoverRating(0);
  };
  const onSaveRating = (index) => {
    setRating(index);
  };
  //Fin calificación estrella

  let matriz = returnMatrix(props.pregunta.list_Plantilla_Opciones);

  return (
    <Form.Group
      className="shadow-sm mb-5 rounded"
      style={{ border: "0.1px solid #ced4da" }}
    >
      <div className="estiloFondo">
        <div
          className="b pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-center align-items-center"
          style={{ height: "2rem" }}
        >
          <Button size="sm" className="btn rounded-circle" disabled></Button>
        </div>
      </div>
      <div className="pl-3 pr-3 pb-3">
        <Form>
          <Row>
            <Form.Group
              as={Col}
              className="mb-3"
              sm="12"
              md="12"
              lg="12"
              xl="12"
            >
              <Col
                className="mt-3 p-3 shadow-sm d-flex flex-wrap justify-content-between align-items-center rounded"
                style={{ borderBottom: "0.1px solid #ced4da" }}
                sm="12"
                md="12"
                lg="12"
                xl="12"
              >
                <h6 className="m-0">
                  {props.pregunta ? props.pregunta.pregunta : null}
                </h6>
              </Col>
            </Form.Group>
          </Row>
        </Form>
        <Row>
          <Form.Group as={Col} className="mb-3">
            <>
              {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                "Matriz/escala valoración".toLowerCase() && (
                <Row className="d-flex flex-wrap justify-content-center align-items-center text-justify">
                  {matriz.map((item) => (
                    <>
                      <Row>
                        <Form.Group
                          as={Col}
                          sm="1"
                          md="1"
                          lg="1"
                          xl="1"
                          className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                        >
                          <Col
                            className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {parseInt(item)}
                          </Col>
                          <input
                            className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                            type="radio"
                            name="allemployyes1[]"
                          />
                        </Form.Group>
                      </Row>
                    </>
                  ))}
                </Row>
              )}
              {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                "MENU DESPLEGABLE".toLowerCase() && (
                <Form.Group
                  as={Col}
                  className="mb-3"
                  sm="12"
                  md="8"
                  lg="8"
                  xl="8"
                >
                  <Form.Control
                    as="select"
                    id="categoria"
                    name="categoria"
                    className="rounded-pill"
                    placeholder="Categoría"
                  >
                    {props.pregunta.list_Plantilla_Opciones
                      .sort((a, b) => {
                        if (a.posicion !== null && b.posicion !== null) {
                          if (parseInt(a.posicion) === parseInt(b.posicion)) {
                            return 0;
                          }
                          if (parseInt(a.posicion) < parseInt(b.posicion)) {
                            return -1;
                          }
                        }
                        return 1;
                      })
                      .map((item) => (
                        <>
                          <option key={item.id} value={item.id ? item.id : ""}>
                            {item.respuesta ? item.respuesta.toUpperCase() : ""}
                          </option>
                        </>
                      ))}
                  </Form.Control>
                </Form.Group>
              )}
              <Row>
                {props.pregunta.list_Plantilla_Opciones
                  .sort((a, b) => {
                    if (a.posicion !== null && b.posicion !== null) {
                      if (
                        parseInt(a.posicion) === parseInt(b.posicion) &&
                        parseInt(a.id) > parseInt(b.id)
                      ) {
                        return 1;
                      }

                      if (
                        parseInt(a.posicion) === parseInt(b.posicion) &&
                        parseInt(a.id) < parseInt(b.id)
                      ) {
                        return -1;
                      }

                      if (parseInt(a.posicion) < parseInt(b.posicion)) {
                        return -1;
                      }
                    }
                    if (parseInt(a.id) > parseInt(b.id)) {
                      return 1;
                    } else {
                      return -1;
                    }
                  })
                  .map((item, index) => {
                    return (
                      <Col sm="12" md="12" lg="12" xl="12" key={item.id}>
                        {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                          "OPCIÓN MÚLTIPLE".toLowerCase() && (
                          <Row className="pl-3 pr-3 mb-3">
                            <Col
                              sm="1"
                              md="1"
                              lg="1"
                              xl="1"
                              className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                            >
                              <input
                                // onChange={handleCheckbox}
                                className=""
                                type="radio"
                                name="allemployyes1[]"
                                value={item.id}
                              />
                            </Col>
                            <Col
                              sm="10"
                              md="10"
                              lg="10"
                              xl="10"
                              style={{
                                borderBottom: "0.1px solid #ced4da",
                                padding: "0.5rem",
                              }}
                              className="shadow-sm rounded d-flex flex-wrap justify-content-center align-items-center"
                            >
                              <Col
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {item.respuesta}
                              </Col>
                            </Col>
                          </Row>
                        )}
                        {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                          "CASILLAS DE VERIFICACIÓN".toLowerCase() && (
                          <Row className="pl-3 pr-3 mb-3">
                            <Col
                              sm="1"
                              md="1"
                              lg="1"
                              xl="1"
                              className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                            >
                              <input
                                // onChange={handleCheckbox}
                                className=""
                                type="checkbox"
                                name="allemployyes1[]"
                                value={item.id}
                              />
                            </Col>
                            <Col
                              sm="10"
                              md="10"
                              lg="10"
                              xl="10"
                              style={{
                                borderBottom: "0.1px solid #ced4da",
                                padding: "0.5rem",
                              }}
                              className="shadow-sm rounded d-flex flex-wrap justify-content-center align-items-center"
                            >
                              <Col
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {item.respuesta}
                              </Col>
                            </Col>
                          </Row>
                        )}
                        {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                          "Verdadero y falso".toLowerCase() && (
                          <Col>
                            <VerdaderoFalso descrip="Verdadero" />
                            <VerdaderoFalso descrip="Falso" />
                          </Col>
                        )}
                        {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                          "CAMPO TEXTO SIMPLE".toLowerCase() && (
                          <Form.Group>
                            <Row className="px-3">
                              <Col
                                className="p-0 mb-3 d-flex flex-wrap justify-content-center align-items-start"
                                xs="12"
                                sm="12"
                                md="12"
                                lg="12"
                                xl="12"
                              >
                                <Form.Control
                                  name="pregunta"
                                  className="rounded-pill"
                                  required
                                  type="text"
                                  pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                                  placeholder="Texto de respuesta simple"
                                ></Form.Control>
                              </Col>
                            </Row>
                          </Form.Group>
                        )}
                        {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                          "CAMPO TEXTO LIBRE".toLowerCase() && (
                          <Form.Group>
                            <Row>
                              <Col
                                className="mb-3 d-flex flex-wrap justify-content-center align-items-center"
                                sm="12"
                                md="12"
                                lg="12"
                                xl="12"
                              >
                                <Form.Control
                                  name="pregunta"
                                  required
                                  as="textArea"
                                  pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                                  placeholder="Texto de respuesta larga"
                                ></Form.Control>
                              </Col>
                            </Row>
                          </Form.Group>
                        )}
                        {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                          "Valoración por estrellas".toLowerCase() && (
                          <Row className="box d-flex ml-3">
                            {[1, 2, 3, 4, 5].map((index) => {
                              return (
                                <RatingIcon
                                  index={index}
                                  rating={rating}
                                  hoverRating={hoverRating}
                                  onMouseEnter={onMouseEnter}
                                  onMouseLeave={onMouseLeave}
                                  onSaveRating={onSaveRating}
                                />
                              );
                            })}
                          </Row>
                        )}
                        {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                          "FECHA/Hora".toLowerCase() && (
                          <Form.Group>
                            <Row>
                              <Form.Group
                                as={Col}
                                className="mb-3"
                                sm="12"
                                md="8"
                                lg="8"
                                xl="8"
                              >
                                <Row>
                                  <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                    <Form.Control
                                      name="fecha"
                                      className="rounded-pill"
                                      required
                                      type="date"
                                      placeholder="Año/Mes/Día   HH:MM"
                                    ></Form.Control>
                                  </Col>
                                </Row>
                              </Form.Group>
                            </Row>
                          </Form.Group>
                        )}
                      </Col>
                    );
                  })}
              </Row>
            </>
          </Form.Group>
        </Row>
      </div>
    </Form.Group>
  );
};

export default withRouter(CampoPreguntaEncuesta);
